import { ref, push } from "firebase/database";
import { db } from "../firebase";
import getEnvironment from "./environment";
import { DEFAULT_MODE, providerForMode } from "./modes";

export default function createChatLocal(uid: string, mode: string = DEFAULT_MODE): string {
    const chatRef = ref(db, "chats");
    const now = Date.now();
    const chatData = {
        title: "New Chat",
        time: now,
        lastMessage: now,
        userId: uid,
        incomingUrl: window.location.hostname.split('.com')[0],
        environment: getEnvironment(),
        provider: providerForMode(mode)
    };
    const newChatRef = push(chatRef, chatData);

    return newChatRef.key!;
}
